import React from 'react'
import './loading.scss'
const Loading = () => {
    return (
        <div className='grid-gap-24 loading'>
            <div className='loading-block'>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='loading-block'>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='loading-block'>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className='loading-block'>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loading